@if (reportGroupWithDefinitions().group.groupInfo.isGrouped) {
  <gc-accordion [expanded]="true">
    <ng-template #gcAccordionHeader>
      <div class="accordion-header">
        <gc-icon
          [iconName]="isAllComplete() ? 'circleCheck' : 'circleClose'"
          [color]="isAllComplete() ? 'success' : 'primary'"
        />
        <gc-text>
          {{ accordionHeader() }}
        </gc-text>
      </div>
    </ng-template>
    <ng-template #gcAccordionBody>
      <ng-container *ngTemplateOutlet="selfInspections" />
    </ng-template>
  </gc-accordion>
} @else {
  <ng-container *ngTemplateOutlet="selfInspections" />
}

<ng-template #selfInspections>
  <div class="accordion-body">
    @for (
      definition of reportGroupWithDefinitions().definitions;
      track $index
    ) {
      @switch (definition.type) {
        @case (definitionTypes.TEXT) {
          <app-self-inspection-text
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (saveTextInput)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (undoSelfInspection)="
              undoSelfInpseciton(definition.id, reportId, reportGroup())
            "
          />
        }
        @case (definitionTypes.RADIOBUTTON) {
          <app-self-inspection-radio-button
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (checkedValue)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (undoSelfInspection)="
              undoSelfInpseciton(definition.id, reportId, reportGroup())
            "
          />
        }
        @case (definitionTypes.CHECKBOX) {
          <app-self-inspection-checkbox
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (markAsDone)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (undoSelfInspection)="
              undoSelfInpseciton(definition.id, reportId, reportGroup())
            "
          />
        }
        @case (definitionTypes.LIST) {
          <app-self-inspection-list
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (saveInputs)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
          />
        }
        @case (definitionTypes.FILES) {
          <app-self-inspection-files
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (viewImages)="
              openImagePreview(
                reportAnswers[$index].data,
                reportId,
                reportGroup(),
                false
              )
            "
            (uploadFiles)="
              saveFile($event, definition, reportId, reportGroup(), false)
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (undoSelfInspection)="
              undoSelfInpseciton(definition.id, reportId, reportGroup())
            "
            (fileDelete)="
              deleteFile(definition.id, $event, reportId, reportGroup())
            "
            (filesDownload)="downloadFiles($event)"
          />
        }
        @case (definitionTypes.FILE_AND_TEXT) {
          <app-self-inspection-file-and-text
            [data]="reportAnswers[$index].data"
            [wrapperData]="reportAnswers[$index].wrapperData"
            (viewImages)="
              openImagePreview(
                reportAnswers[$index].data,
                reportId,
                reportGroup(),
                true
              )
            "
            (uploadFiles)="
              saveFile($event, definition, reportId, reportGroup(), true)
            "
            (saveTextInput)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (markAsNA)="
              saveAnswer($event, definition.id, reportId, reportGroup())
            "
            (undoSelfInspection)="
              undoSelfInpseciton(definition.id, reportId, reportGroup())
            "
            (fileDelete)="
              deleteFile(definition.id, $event, reportId, reportGroup())
            "
            (filesDownload)="downloadFiles($event)"
          />
        }
      }
    }
  </div>
</ng-template>
